import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import languagePackageEng from './en.json';

const loadI18next = async () => {
   await i18next.use(initReactI18next).init({
      interpolation: { escapeValue: false },
      lng: 'en',
      resources: {
         en: {
            translation: languagePackageEng,
         },
      },
      // Dev only, and never under vitest (which runs with DEV=true). Left on
      // unconditionally this dumps the entire i18next config to the console on
      // every init — ~35 times through a CI test run, and in every production
      // browser session.
      debug: import.meta.env.DEV && !import.meta.env.VITEST,
      fallbackLng: 'en',
   });
};

loadI18next().catch(error => {
   console.log('initReactI18next', error);
});

export default i18next;
